import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').factory('Surrender', surrenderCapacityService);

    /**
     * Should map SurrenderResource.java
     *
     * @param $resource
     * @param API_URL
     * @returns {*}
     * @author flzemke.btc
     */
    function surrenderCapacityService($resource, API_URL) {
        return $resource(
            API_URL.SURRENDER,
            {},
            {
                checkPlausibility: {
                    method: 'POST',
                    url: API_URL.SURRENDER + '/checkPlausibility'
                },
                submitConfirmation: {
                    method: 'POST',
                    url: API_URL.SURRENDER + '/submitConfirmation'
                },
                getSurrenderRequests: {
                    url: API_URL.SURRENDER + '/getSurrenderRequests',
                    method: 'GET'
                },
                getSurrender: {
                    url: API_URL.SURRENDER + '/:id',
                    method: 'GET',
                    params: {
                        id: '@id'
                    }
                },
                getConfig: {
                    url: API_URL.SURRENDER + '/config/:id',
                    method: 'GET'
                },
                getDealIds: {
                    url: API_URL.SURRENDER + '/getDealIds/:id',
                    method: 'GET',
                    isArray: true
                }
            }
        );
    }
})();
